const messages = {
  imageDescription: 'Hi, ich bin Tania',
  imageAlt: 'Portraitbild von Tania am Zürichsee',
  descriptionText1:
    'Was mich von anderen Trainern unterscheidet? Mein fundiertes Wissen, das ich mir mit meinem Masterstudium in Bewegungswissenschaften und Sport an der ETH Zürich angeeignet habe. Schon seit Jahren bin ich in der Gesundheits- und Sportbranche tätig und es gibt nichts was ich lieber mache, als meine Leidenschaft für Sport weiterzugeben.\n\nAls deine Personal Trainerin kann ich dir helfen, deine verlorene Motivation zu finden oder mit deinem neuen Lifestyle-Projekt anzufangen. Wäre es nicht grossartig, sich fit und energisch zu fühlen und einen Körper zu haben, auf den man stolz sein kann?',
}

export default messages
